// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aJNY5NUTebOGYqZsjLEd{
    display: flex;
    flex-direction: column;
    justify-content: left;
    align-items: flex-start;
    box-sizing: border-box;
    padding: 16px 0px;
    width: 100%;
    overflow-y: auto;
    height: 100%;
}

.x1u8Up0iEoco2be05HLJ, ._Tne9SBsNA4N2fuxJCdv{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    height: 32px;

    
}
.x1u8Up0iEoco2be05HLJ{
    width: 336px;
    margin: 0px 8px;
}

._Tne9SBsNA4N2fuxJCdv{
    flex-grow: 1;
    margin-left: 8px;
}


.EFkuoWfw4_HgHY7WynO9{
    display: flex;
    flex-direction: row;
    align-items: center;
    box-sizing: border-box;
    height: 32px;
    overflow: hidden;
    justify-content: flex-start;
    color: var(--letter-light);
}

.XVw5Qqp87frT015OFnGU{
    display: flex;
    flex-direction: column;
    align-items: left;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    margin-bottom: 16px;
}

.lTC3vSngdMhpQV4jMhGB{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    box-sizing: border-box;
    margin: 0px;
    width: 100%;
    overflow-y: auto;
    height: 100%;
    padding: 0px  0px 0px 8px;
}

.lTC3vSngdMhpQV4jMhGB::-webkit-scrollbar {
    width: 4px;
}

.lTC3vSngdMhpQV4jMhGB::-webkit-scrollbar-track {
    background: transparent; /* Color of the scrollbar track */
}

.lTC3vSngdMhpQV4jMhGB::-webkit-scrollbar-thumb {
    background-color: var(--scrollbar-regular); /* Color of the scrollbar itself */
}

.lTC3vSngdMhpQV4jMhGB::-webkit-scrollbar-thumb:hover {
    background-color: var(--scrollbar-hover); /* Color on hover */
}

.lTC3vSngdMhpQV4jMhGB::-webkit-scrollbar-thumb:active {
    background-color: var(--scrollbar-onClick); /* Color on click */
}

.lTC3vSngdMhpQV4jMhGB::-webkit-scrollbar-corner {
    background-color: transparent; /* Set the corner color to match your design */
}`, "",{"version":3,"sources":["webpack://./clientRoot/Static/GlobalComponents/CommonStyles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;;;AAGhB;AACA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB,EAAE,iCAAiC;AAC9D;;AAEA;IACI,0CAA0C,EAAE,kCAAkC;AAClF;;AAEA;IACI,wCAAwC,EAAE,mBAAmB;AACjE;;AAEA;IACI,0CAA0C,EAAE,mBAAmB;AACnE;;AAEA;IACI,6BAA6B,EAAE,8CAA8C;AACjF","sourcesContent":[".SOHeader{\n    display: flex;\n    flex-direction: column;\n    justify-content: left;\n    align-items: flex-start;\n    box-sizing: border-box;\n    padding: 16px 0px;\n    width: 100%;\n    overflow-y: auto;\n    height: 100%;\n}\n\n.headerButtons, .detailsAndCostButtons{\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    box-sizing: border-box;\n    height: 32px;\n\n    \n}\n.headerButtons{\n    width: 336px;\n    margin: 0px 8px;\n}\n\n.detailsAndCostButtons{\n    flex-grow: 1;\n    margin-left: 8px;\n}\n\n\n.parameterRow{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    box-sizing: border-box;\n    height: 32px;\n    overflow: hidden;\n    justify-content: flex-start;\n    color: var(--letter-light);\n}\n\n.parametersColumn{\n    display: flex;\n    flex-direction: column;\n    align-items: left;\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    margin-bottom: 16px;\n}\n\n.mainView{\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    box-sizing: border-box;\n    margin: 0px;\n    width: 100%;\n    overflow-y: auto;\n    height: 100%;\n    padding: 0px  0px 0px 8px;\n}\n\n.mainView::-webkit-scrollbar {\n    width: 4px;\n}\n\n.mainView::-webkit-scrollbar-track {\n    background: transparent; /* Color of the scrollbar track */\n}\n\n.mainView::-webkit-scrollbar-thumb {\n    background-color: var(--scrollbar-regular); /* Color of the scrollbar itself */\n}\n\n.mainView::-webkit-scrollbar-thumb:hover {\n    background-color: var(--scrollbar-hover); /* Color on hover */\n}\n\n.mainView::-webkit-scrollbar-thumb:active {\n    background-color: var(--scrollbar-onClick); /* Color on click */\n}\n\n.mainView::-webkit-scrollbar-corner {\n    background-color: transparent; /* Set the corner color to match your design */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SOHeader": `aJNY5NUTebOGYqZsjLEd`,
	"headerButtons": `x1u8Up0iEoco2be05HLJ`,
	"detailsAndCostButtons": `_Tne9SBsNA4N2fuxJCdv`,
	"parameterRow": `EFkuoWfw4_HgHY7WynO9`,
	"parametersColumn": `XVw5Qqp87frT015OFnGU`,
	"mainView": `lTC3vSngdMhpQV4jMhGB`
};
export default ___CSS_LOADER_EXPORT___;
